export default function timetableFeedback ({ to }) {
  if (to.query.lesson || to.name === 'timetable-middle') return
  return { name: 'timetable-middle' }
}
